import { Injectable, EventEmitter } from '@angular/core';


@Injectable()
export class FormGroupService {

  model: any = {
    focused: false,
    charLength: 0
  };

  focus(charLength: number) {
    this.setCharLength(charLength);
    this.setFocused(true);
  }

  setFocused(focused: boolean): void {
    this.model.focused = focused;
  }

  setCharLength(length: number): void {
    this.model.charLength = length;
  }

}
